/** Public video deliverables accept web URLs only, in the same precedence as authoring readiness. */
export function publicVideoSource(override?: string | null, droneUrl?: string | null, outputUrl?: string | null): string | null {
  const candidate = override?.trim() || droneUrl?.trim() || outputUrl?.trim();
  if (!candidate) return null;
  try {
    const url = new URL(candidate);
    return (url.protocol === "http:" || url.protocol === "https:") && !url.username && !url.password ? url.href : null;
  } catch { return null; }
}
